import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Asset1 from "../../assets/image/asset1.webp";
import Assetdark1 from "../../assets/image/asset1-dark.webp";
import Asset2 from "../../assets/image/asset2.webp";
import Assetdark2 from "../../assets/image/asset2-dark.webp";
import Asset3 from "../../assets/image/asset3.webp";
import Assetdark3 from "../../assets/image/asset3-dark.webp";
import Asset4 from "../../assets/image/asset4.webp";
import Assetdark4 from "../../assets/image/asset4-dark.webp";
import Asset5 from "../../assets/image/asset5.webp";
import Assetdark5 from "../../assets/image/asset5-dark.webp";
import Asset6 from "../../assets/image/asset6.webp";
import Assetdark6 from "../../assets/image/asset6-dark.webp";
import Asset7 from "../../assets/image/asset7.webp";
import Assetdark7 from "../../assets/image/asset7-dark.webp";
import Asset8 from "../../assets/image/asset8.webp";
import Assetdark8 from "../../assets/image/asset8-dark.webp";
import Asset9 from "../../assets/image/asset9.webp";
import Assetdark9 from "../../assets/image/asset9-dark.webp";
import { useSelector } from "react-redux";

const partnerLogos = [
  { light: Asset1, dark: Assetdark1, redirectUrl: "https://comtechgold.com" },
  { light: Asset2, dark: Assetdark2, redirectUrl: "https://storx.tech" },
  { light: Asset3, dark: Assetdark3, redirectUrl: "https://x.com/AGG_GAME" },
  { light: Asset4, dark: Assetdark4, redirectUrl: "https://firework.com/" },
  { light: Asset5, dark: Assetdark5, redirectUrl: "https://decent.xyz/" },
  { light: Asset6, dark: Assetdark6, redirectUrl: "https://nrivision.com/" },
  { light: Asset7, dark: Assetdark7, redirectUrl: "https://www.xvc.tech/" },
  {
    light: Asset8,
    dark: Assetdark8,
    redirectUrl: "https://www.indialaw.in/",
  },
  {
    light: Asset9,
    dark: Assetdark9,
    redirectUrl: "https://www.alketbilaw.com/",
  },
];

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 5,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 1450,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
      },
    },
    {
      breakpoint: 650,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
  ],
};
export default function PartnersSlider() {
  const mode = useSelector((state) => state.theme.mode);
  const isDarkMode = mode !== "light";
  return (
    <>
      <Slider {...settings}>
        {partnerLogos.map((partner, index) => (
          <div
            key={index}
            data-aos="fade-left"
            data-aos-duration="2000"
            className="cursor-pointer d-flex justify-content-center"
          >
            <a
              href={partner.redirectUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              {isDarkMode ? (
                <img src={partner.light} alt={`partner-dark-${index + 1}`}/>
              ) : (
                <img src={partner.dark} alt={`partner-${index + 1}`} />
              )}
            </a>
          </div>
        ))}
      </Slider>
    </>
  );
}
